import React, { Component } from "react";
import { connect } from "react-redux";
import { Header, Icon } from "semantic-ui-react";
import "./loader.css";
class NotFound extends Component {
  render() {
    return (
      <Header as="h1">
        <Icon name="hand spock" />
        Page Is not found
      </Header>
    );
  }
}
function mapStateToProps(state) {
  return {
    showModal: state.modal === "loading"
  };
}
export default connect(mapStateToProps)(NotFound);



// WEBPACK FOOTER //
// ./src/components/shared-components/404.js